import $ from 'jquery'

export const csrfParam = () => $("meta[name=csrf-param]").attr("content")
export const csrfValue = () => $("meta[name=csrf-token]").attr("content")

export function addCSRF(data) {
  data[csrfParam()] = csrfValue()
  return data
}